import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Drawer from '@mui/material/Drawer';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import MenuIcon from '@mui/icons-material/Menu';
import { useState, useEffect } from 'react';
import { drawerClasses } from '@mui/material/Drawer';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import MenuContent from './MenuContent';
import AlertVerifyEmail from './AlertVerifyEmail';
import OptionsMenu from './OptionsMenu';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, useColorScheme, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material';
import { auth, logout } from '../../contexts/authentication';
import { UserData, getUser } from '../pages/getUserDB';
import { useNavigate } from 'react-router-dom';
import logoCabanaWhite from '../images/logonextcabana-white.svg';
import logoCabanaBlack from '../images/logonextcabana-dark.svg';

const drawerWidth = 240;

export default function SideMenu() {
  const [userDB, setUserDB] = useState<UserData | null>(null);
  const [loading, setLoading] = useState(true);
  const { mode, systemMode } = useColorScheme();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const [open, setOpen] = React.useState(true);
  const [isEmailVerified, setIsEmailVerified] = useState(true);
  const currentUser = auth.currentUser;
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser?.emailVerified) return;

    const interval = setInterval(async () => {
      await currentUser?.reload();
      if (!currentUser?.emailVerified) {
        clearInterval(interval);
        setIsEmailVerified(false);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [currentUser]);

  const handleToggleDrawer = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <div style={{ width: open && isDesktop ? drawerWidth : 0, }}>
      {isDesktop && (
        <div onClick={handleToggleDrawer} style={{
          position: 'fixed',
          top: '40px',
          cursor: 'pointer',
          left: open ? `${drawerWidth}px` : '10px',
          transform: 'translateX(-50%)',
          transition: 'left 0.3s ease-in-out',
          zIndex: 9999,
        }}
        >
          {open ? <ChevronLeftIcon sx={{ width: '30px', height: '30px' }} />
            : <ChevronRightIcon sx={{ width: '30px', height: '30px' }} />}
        </div>
      )}
      <Drawer
        variant="persistent"
        open={open}
        anchor="left"
        sx={{
          display: { xs: 'none', md: 'block' },
          width: drawerWidth,
          flexShrink: 0,
          [`& .${drawerClasses.paper}`]: {
            backgroundColor: 'background.paper',
            width: drawerWidth,
            flexShrink: 0,
          },
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <img
            src={mode === 'dark' || systemMode === 'dark' ? logoCabanaWhite : logoCabanaBlack}
            alt="logo-cabanalink"
            style={{ width: '200px', height: 'auto', marginTop: '20px', marginBottom: '10px' }}
          />
        </div>
        <Box
          sx={{
            overflow: 'auto',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <MenuContent />
          {!isEmailVerified && <AlertVerifyEmail />}
          <Stack sx={{ borderTop: '1px solid', borderColor: 'divider' }}>
            <List dense>
              <ListItem disablePadding sx={{ display: 'block' }}>
                <ListItemButton onClick={() => {
                  logout();
                  navigate('/');
                }}>
                  <LogoutRoundedIcon />
                  <ListItemText primary='Sair' />
                </ListItemButton>
              </ListItem>
            </List>
          </Stack>
        </Box>
        <Stack
          onClick={() => navigate('/profile')}
          direction="row"
          sx={{
            p: 2,
            gap: 1,
            alignItems: 'center',
            borderTop: '1px solid',
            borderColor: 'divider',
            cursor: 'pointer',
            '&:hover': {
              bgcolor: 'action.hover',
            },
          }}
        >
          {currentUser?.providerData[0].providerId === 'google.com' && (
            <Avatar
              sizes="small"
              alt={currentUser?.displayName || 'Profile Picture'}
              src={currentUser?.photoURL}
              sx={{ width: 36, height: 36 }}
            />
          )}
          < Box sx={{ mr: 'auto' }}>
            <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: '16px' }}>
              {currentUser?.displayName}
            </Typography>
            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              {currentUser?.email}
            </Typography>
          </Box>
        </Stack>
      </Drawer>
    </div >
  );
}